const handlerAccordeon = (containerId: string) => {

  const accordeonContainer = document.getElementById(containerId);
  if (!accordeonContainer) return;

  const items = accordeonContainer?.querySelectorAll(".vfaq__accordion-header");

  if (!items) return;

  items.forEach((header) => {
    header.addEventListener("click", () => {
      const parentItem = header.parentElement;

      if (!parentItem) return;
      if (parentItem.classList.contains("active")) {
        parentItem.classList.remove("active");
        return;
      }

      // Cierra todas las secciones abiertas
      accordeonContainer.querySelectorAll(".accordion-item").forEach((item) => {
        item.classList.remove("active");
      });

      // Abre la sección actual (si no estaba ya abierta)

      if (!parentItem.classList.contains("active")) {
        parentItem.classList.add("active");
      }
    });
  });
};

const createProductsNavigation = () => {
  const container = document.getElementById("ourbeerProducts");
  if (!container) return;  
  const newContainer = document.querySelector(".ourbeer__sizes");

  const siluets = container?.querySelectorAll(".ourbeer__translate");

  siluets?.forEach((item, index) => {
    item.addEventListener("click" , () => {
      const parentElemnt = item.parentElement;
      parentElemnt?.querySelectorAll(".ourbeer__translate").forEach((item) => {
        item.classList.remove("active");
      });

      item.classList.add("active")

      container.querySelectorAll(".ourbeer__product").forEach((item) => {
        item.classList.remove("active");
      });
      const productSelected = container?.querySelector(`#product${index+1}`);
      productSelected?.classList.add("active")
    })
    newContainer?.appendChild(item);
  })

  /** Cambiar color de latas */

}

document.addEventListener("DOMContentLoaded", () => {
  handlerAccordeon("faqAccordeon");
  createProductsNavigation();
});
